import { reactify } from '@zeiss/zui-react';
export const ZuiIconCommonCompareViewVertical = reactify('zui-icon-common-compare-view-vertical');
